import React, { Component } from 'react';

class OnSale extends React.Component {
	
	constructor( props ){
		super( props );

		this.state = {
			onSale: true,
		}

	}

	checkChanged = (e) => {
		
		if( e.target.getAttribute('class').indexOf('checked') > -1 ) {
			e.target.setAttribute('class', 'checkbox')
		} else {
			e.target.setAttribute('class', 'checkbox checked')
		}		
		
		let temp = !this.state.onSale;

		this.setState({
			onSale : temp
		});
		
		this.props.setFilters({
			onSale: this.state.onSale ? '1' : '0'
		});

	}

	render() {
		return (
			<div>
				<div className="filter-head">Udsalg: </div>
				<ul className="checkbox-wrapper">
					<li>
						<span data-value="m" className="checkbox" onClick={ this.checkChanged } >
							Aktuelle Tilbud
						</span>
					</li>
				</ul>
			</div>
		)
	}
}

export default OnSale;


// WEBPACK FOOTER //
// ./src/Reducer/Filters/OnSale.js